const formatAddress = (address) => {
  if (typeof address === 'object' && address !== null) {
    const {
      country,
      city,
      region,
      streetName,
      streetNumber,
      district,
      postalTown
    } = address

    return [
      country,
      city,
      region,
      streetName,
      streetNumber,
      district,
      postalTown
    ]
      ?.filter(Boolean)
      ?.join(', ')
  } else {
    return null
  }
}

export default formatAddress
